import { Component } from '@angular/core';
import { NavController, NavParams,LoadingController,AlertController,ModalController,ViewController } from 'ionic-angular';
import { DbservicesProvider,ChatService } from '../../providers/dbservices/dbservices';
import {MarkaspaidPage} from '../../pages/markaspaid/markaspaid';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial';
import * as qz from 'qz-tray';
import { PrintProvider } from '../../providers/print/print';
import {DeliveryTimePage} from '../../pages/delivery-time/delivery-time';
import { Pipe, PipeTransform } from '@angular/core';

@Component({
  selector: 'page-orders',
  templateUrl: 'orders.html',
})
export class OrdersPage {

	orders = 'Pending';
	order_type;
  order_list = [];
  pending_list = [];
  pageNo = 0;
  ppageNo = 0;
  loadMoreData = false;
  ploadMoreData = false;
  pageNos = false;
  ppageNos = false;
  apageNos = false;
  connection;
  messages:any;
  Isorder = false;
  Isordercomplete = false;
  show;
  item;
  active= -1;
  out_for_delivery=[];
  resturant;
  delivery_slot;


  constructor(public print:PrintProvider,public btSerial:BluetoothSerial, public loadingCtrl: LoadingController,public alertCtrl: AlertController, public viewCtrl: ViewController, public modalCtrl: ModalController,private chatService: ChatService,public DBservice: DbservicesProvider,public navCtrl: NavController, public navParams: NavParams) {
  if(navParams.get('page'))
       this.order_type = 'Completed'
    this.connection = this.chatService.getMessages().subscribe(message => {
    setTimeout(() => {
      this.Isorder = false;
      this.Isordercomplete = false;
      this.order_list = [];
      this.pending_list = [];
      this.pageNo = 0;
      this.ppageNo = 0;
      this.loadMoreData = false;
      this.ploadMoreData = false;
      this.Orderlist(0);
      this.PendingOrderlist(0)
      this.OutfordeliveryOrderlist(0)
    }, 1000);

    })


      this.Isorder = false;
      this.Isordercomplete = false;
      this.order_list = [];
      this.pending_list = [];
      this.pageNo = 0;
      this.ppageNo = 0;
      this.loadMoreData = false;
      this.ploadMoreData = false;
      this.Orderlist(0);
      this.PendingOrderlist(0)
      this.OutfordeliveryOrderlist(0)
      this.get_restaurant_preparation_time()
      this.get_restaurant()
  }

  get_restaurant() {
    this.DBservice.get_restaturantdetail(localStorage.restaurant)
      .then(data => {
        console.log(data);
        this.resturant = data.message[0];
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
       var aa= new Date()
    var date = aa.getFullYear() + '-' + (this.getPaddedComp(aa.getMonth() + 1)) + '-' + this.getPaddedComp(aa.getDate());
    if (localStorage.AdminId != undefined && date == localStorage.setdate) {

      var logindata = {
        username: localStorage.AdminId,
        password: localStorage.AdminPwd
      }
      this.DBservice.getLogin(logindata).then(
        data => {
          var currentDate = new Date()
          localStorage.setdate = currentDate.getFullYear() + '-' + (this.getPaddedComp(currentDate.getMonth() + 1)) + '-' + this.getPaddedComp(currentDate.getDate() +1);
        }, error => {
          console.log(JSON.stringify(error.json()));
        });
    }
  }

  getPaddedComp(comp) {
    return ((parseInt(comp) < 10) ? ('0' + comp) : comp)
  }


  get_restaurant_preparation_time(){
    var orderdata = {
      business:localStorage.restaurant
    }
    this.DBservice.get_restaurant_preparation_time(orderdata)
      .then(data => {
        console.log(data);
        this.delivery_slot = data.message;
        
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }


 refresh(){
      this.Isorder = false;
      this.Isordercomplete = false;
      this.order_list = [];
      this.pending_list = [];
      this.pageNo = 0;
      this.ppageNo = 0;
      this.loadMoreData = false;
      this.ploadMoreData = false;
      this.Orderlist(0);
      this.PendingOrderlist(0)
      this.OutfordeliveryOrderlist(0)

 }


  ionViewWillEnter() {
    this.PendingOrderlist(0);
      
    }

 All_list(){

 }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OrderPage');
  }

  order_tab(order_type) {
    
  }

  Orderlist(page) {
    var orderdata = {
      restaurantId:localStorage.restaurant,
      limit_start: page,
      limit_page_length: 10,
      status: ''
    }
    this.DBservice.order_list(orderdata)
      .then(data => {
        console.log(data)
        if (data.message != undefined) {
          for (var i = 0; i < data.message.length; i++) {
            var k = i;
            this.order_list.push(data.message[k])
          }
          console.log(this.order_list);
          if (data.message.length == 0) {
            this.loadMoreData = true;
          }
          if(this.order_list.length == 0)
            this.Isorder = true;
        this.pageNos = true
        }
        else {
          this.Isorder = true;
          this.pageNos = false;
          this.loadMoreData = true;
        }
        if(this.order_list.length != 0)
          this.Isorder = false;
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  startCountdown(seconds) {
  //    const minutes = Math.floor(Number(seconds.preparation_time) * 60);
  //   console.log(minutes)
  //   // if(minutes == 0)
  //     // return ('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(value - minutes * 60)).slice(-2);
  // let counter = minutes;
    
  // const interval = setInterval(() => {
  //   console.log(counter);
  //    counter--;
  //    return counter;
  //   // return seconds.time = counter;
  //   if (counter < 0 ) {
  //     clearInterval(interval);
  //     console.log('Ding!');
  //   }
  // }, 1000);
}

  PendingOrderlist(page) {
    // var orderdata = {
    //   restaurantId:localStorage.restaurant,
    //   limit_start: 0,
    //   limit_page_length: 50,
    //   status: 'Placed'
    // }
    // this.DBservice.order_list(orderdata)
    //   .then(data => {
    //     console.log(data);
    //     if (data.message != undefined) {
    //       this.pending_list = data.message
    //     }
    //     if(this.pending_list.length != 0)
    //       this.Isordercomplete = false;
    //   }, error => {
    //     console.log(JSON.stringify(error.json()));
    //   });

    // (limit_page_length,limit_start,restaurantId,status=None,restaurant_status=None,driver_status=None,workflow_state=None,date=None, start_date=None, end_date=None)
    var orderdata = {
      restaurantId:localStorage.restaurant,
      limit_start: 0,
      limit_page_length: 50,
      status:"Processing,Placed",
      driver_status:"Pending"
    }
    this.DBservice.stauts_based_admin_orderlist(orderdata)
      .then(data => {
        console.log(data);
        if (data.message != undefined) {
          this.pending_list = data.message
        }
        if(this.pending_list.length != 0)
          this.Isordercomplete = false;

        // for(var i=0; i < this.pending_list.length;i++){
        //   var k=i;
        //   this.pending_list[k].time= this.startCountdown(this.pending_list[k])
        // }
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

   OutfordeliveryOrderlist(page) {
    

    // (limit_page_length,limit_start,restaurantId,status=None,restaurant_status=None,driver_status=None,workflow_state=None,date=None, start_date=None, end_date=None)
    var orderdata = {
      restaurantId:localStorage.restaurant,
      limit_start: 0,
      limit_page_length: 50,
      status:"Processing",
      driver_status:"Accepted",
      // workflow_state:"Out For Delivery"
    }
    this.DBservice.stauts_based_admin_orderlist(orderdata)
      .then(data => {
        console.log(data);
        if (data.message != undefined) {
          this.out_for_delivery = data.message
        }
        // if(this.pending_list.length != 0)
        //   this.Isordercomplete = false;
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  doInfinite(infiniteScroll) {
    if (this.pageNos == true) {
      this.pageNo = this.pageNo + 10;
      this.Orderlist(this.pageNo);
    }
    setTimeout(() => {
      infiniteScroll.complete();
    }, 50);
  }

  doInfinitePending(infiniteScroll) {
    if (this.ppageNos == true) {
      this.ppageNo = this.ppageNo + 10;
      this.PendingOrderlist(this.ppageNo);
    }
    setTimeout(() => {
      infiniteScroll.complete();
    }, 50);
  }


  doRefresh(refresher) {
    this.order_list = [];
    this.pageNo = 0;
    this.loadMoreData = false;
    this.pageNos = false;
    this.pending_list = [];
    this.ppageNo = 0;
    this.ploadMoreData = false;
    this.ppageNos = false;
    this.PendingOrderlist(this.ppageNo);
    this.Orderlist(this.pageNo)
    this.OutfordeliveryOrderlist(0)
    this.show = false
    setTimeout(() => {
      refresher.complete();
    }, 1000);
  }

  orderdetail(list,index) {
  	this.show = 1;
    if(window.innerWidth <= 768){
      this.navCtrl.push('OrderdetailsPage', { item: list })
    }
    else{
      this.item = list;
      this.active = index;
    }
    // console.log(window.innerWidth)
    // console.log(window.width())
    // window.innerWidth()

    // this.navCtrl.push('OrderdetailsPage', { item: list })
  }

  new_order(){
    this.show = 0;
    this.active = -1;
  }

  Cancelstatus(item) {
    console.log(item)
    let alert = this.alertCtrl.create({
      title: 'Alert',
      message: 'Do you wish to cancel this order?',
      buttons: [
        {
          text: 'Yes',
          handler: () => {
            var data={
              status: 'Restaurant Declined',
               name:item.name
              }
            this.DBservice.update_order(data)
              .then(data => {
                 this.item = undefined;
                  this.show = false;
                  this.refresh();
                // this.navCtrl.pop()
                this.DBservice.alert('Order has been Declined')
              }, error => {
                console.log(JSON.stringify(error.json()));
              });
          }
        },
        {
          text: 'No',
          handler: () => {
            
          }
        }
      ]
    });
    alert.present();

  }

  orderpicked(item,status,preparation_time,preparation_time_hr){
    let loader = this.loadingCtrl.create({
      spinner: 'bubbles',
      content: 'Loading Please Wait...'
    });
     loader.present();
      setTimeout(() => { 
        loader.dismiss();
      }, 3000);
    var data={
       status:status,
       name:item.name,
       preparation_time:preparation_time,
       preparation_time_hr:preparation_time_hr
      }

    this.DBservice.update_order(data)
      .then(data => {
       if(status == 'Restaurant Accepted')
       {
         this.item = undefined;
          this.show = false;
          this.refresh();
          this.testprint()
         // this.navCtrl.pop()
         this.DBservice.alert(status)
       }
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  completedorder(item,status){
      // this.valuealert(item)
  // this.valuealert(item)

    // this.navCtrl.push(MarkaspaidPage, {item:item})
    let modal = this.modalCtrl.create(MarkaspaidPage, {item:item, page:'close'});
    modal.present();
    modal.onWillDismiss((value: any) => {
      if (value) {
        this.item = undefined;
          this.show = false;
          this.refresh();
        }
  });
    if(status == 'Order Picked' && item.shipping_method == 'Pickup')
      this.orderpicked(item,'Order Picked','','')
    
  } 

  changestatus(item,status) {

    
    
    
    if(status == 'Restaurant Accepted' && item.order_time == 'ASAP')
    {
      // setTimeout(() => { 
      //   loader.dismiss();
      // }, 50);    
      this.valuealert(item)
    }
    else if(status == 'Order Completed' && item.shipping_method == 'Delivery'){
      let loader = this.loadingCtrl.create({
                spinner: 'bubbles',
                content: 'Loading Please Wait...'
              });
              loader.present();
              var datas = {
                name: item.name,
                status: 'Order Delivered',
              }
              this.DBservice.update_order(datas)
                .then(resdata => {
              //     console.log(data);
                  // this.navCtrl.pop()
                  setTimeout(() => {
                  var orderdata = {
                    name: item.name,
                    status: 'Order Completed'
                  }
                  this.DBservice.update_order(orderdata)
                    .then(res_data => {
                      // console.log(data);
                      // this.navCtrl.pop()
                  this.DBservice.alert(status)
                  this.item = undefined;
                  this.show = false;
          // this.refresh();
                  this.refresh();


                      setTimeout(() => {
                       loader.dismiss();
                      }, 50);
                  
                      }, error => {
                        console.log(JSON.stringify(error.json()));
                      });
                  }, 50);

                  // this.navCtrl.pop()
                }, error => {
                  console.log(JSON.stringify(error.json()));
                });
                 setTimeout(() => {
                   loader.dismiss();
                }, 4000);
    }
    else{  
      let loader = this.loadingCtrl.create({
      spinner: 'bubbles',
      content: 'Loading Please Wait...'
    });
     loader.present();
      // setTimeout(() => { 
      //   loader.dismiss();
      // }, 3000);    
     var data={
        status:status,
         name:item.name
        }
      this.DBservice.update_order(data)
        .then(data => {
          setTimeout(() => { 
          loader.dismiss();
        }, 50);

          this.item = undefined;
          this.show = false;
          this.refresh();
          if(status == 'Restaurant Accepted')
            this.testprint()
          // this.navCtrl.pop()
          // this.testprint()
          this.DBservice.alert(status)
          // if(status == 'Restaurant Accepted')
          //   this.valuealert(item)
        }, error => {
          console.log(JSON.stringify(error.json()));
        });
      }
  }

  printStuff() {
   var config = qz.configs.create("Printer Name");

   var data = [
      'Raw Data\n',
      'More Raw Data\n',
      'Even More Raw Data\n'
   ];

   qz.print(config, data).catch(function(e) { console.error(e); });
  }

  testprint(){
    // this.print.testPrint(localStorage.bluetoothid,com)
    console.log('testprint')
    var ProductList = ''
    var address;
    // var item=componentName;
    var item=this.item;
      for (var i = 0; i < item.order_item.length; i++) {
        var product_name = '';
        // if(item.order_item[i].item_name.length > 18)
          // product_name = this.print.fillspace(18, item.order_item[i].item_name,'backspace').substring(0, 18)
        // else{
          var product = item.order_item[i].item_name;
          product = product.match(/.{1,18}/g)
          console.log(product)
          for(var j=0;j < product.length; j++){
                product_name = product_name + this.print.fillspace(18, product[j],'backspace').trimLeft() + this.print.nextline(product[j+1]);               

          }
          var attribute = '';
          if(item.order_item[i].attribute_description){
            var data = item.order_item[i].attribute_description.replace(/<br>/,'\n')
            var d= data.replace( /(<([^>]+)>)/ig, ' ')
            attribute=  d.trim();
          }
          // var count=0;
          // for(var j=18;j < item.order_item[i].item_name.length; j = j+18){
          //       count =0;
          //       product_name = product_name + this.print.fillspace(j, item.order_item[i].item_name,'backspace').substring(count, j) + this.print.nextline(item.order_item[i].item_name.substring(count, j));
          //       count = count + 18;
          //       j = j+
          // }
        // }
        console.log(item.order_item[i].attribute_description)    
        ProductList = ProductList + product_name + this.print.fillspace(3, item.order_item[i].quantity +'x', 'frontspace')+ ""+this.print.fillspace(5, +item.order_item[i].price, 'frontspace')+ "" +  this.print.fillspace(6, +item.order_item[i].amount, 'frontspace') +"\n" +attribute +this.print.nextline(attribute)
        // ProductList = ProductList +this.print.fillspace(18, item.order_item[i].item_name,'backspace').substring(0, 18)+ this.print.fillspace(3, item.order_item[i].quantity +'x', 'frontspace')+ ""+this.print.fillspace(5, +item.order_item[i].price, 'frontspace')+ "" +  this.print.fillspace(6, +item.order_item[i].amount, 'frontspace') +"\n"
      }
        var label_text;
        var shipping_amount = 0;
        if(item.shipping_charges){
          label_text= 'Delivery';
          shipping_amount= item.shipping_charges;
        }
        else if(item.pickup_charge){
          label_text= 'Pickup';
          shipping_amount= item.pickup_charge;


        }
          let printData=this.print.centeralign(32, this.resturant.restaurant_name).substring(0, 32)+"\n" +this.print.centeralign(32, this.resturant.business_address).substring(0, 32)+"\n"+this.print.centeralign(32, this.resturant.city).substring(0, 32)+this.print.nextline(this.resturant.city)+this.print.centeralign(32, this.resturant.state).substring(0, 32)+this.print.nextline(this.resturant.state)+this.print.centeralign(32, this.resturant.contact_number).substring(0, 32)+"\n"+"\n" +this.print.fillspace(16,"Customer No:" + item.phone, 'backspace') + this.print.nextline(item.phone) + this.print.fillspace(16,"Driver No:" +  this.print.empty(item.driver_phone), 'backspace') + "\n" +this.print.fillspace(16,"Invoice:" + item.name, 'backspace') + "\n" + this.print.fillspace(0,"Date:"+item.order_date +' '+item.order_time,'frontspace')+ "\n" + "--------------------------------\n" + this.print.fillspace(16, "Items", 'backspace') + "  Qty " + "Rate " + "Total\n"+ "--------------------------------\n" +ProductList +"--------------------------------\n" +this.print.fillspace(22, "Sub Total", 'backspace')+this.print.fillspace(10,Math.round(item.order_subtotal*100)/100 ,  'frontspace')+"\n"+this.print.fillspace(22, "Tax", 'backspace')+this.print.fillspace(10,Math.round(item.total_tax_amount*100)/100,'frontspace')+"\n"+this.print.fillspace(22, "Tip Amount", 'backspace')+this.print.fillspace(10, String(item.tip_amount),  'frontspace') +"\n"+this.print.fillspace(22, "Discount", 'backspace')+this.print.fillspace(10, String(item.discount),  'frontspace') +"\n"+this.print.fillspace(22, label_text +" Charges", 'backspace')+this.print.fillspace(10, String(shipping_amount),  'frontspace')+"\n"+"--------------------------------\n" +this.print.fillspace(22, "Total", 'backspace')+this.print.fillspace(10,Math.round(item.total_amount*100)/100 ,  'frontspace')+"\n"+ "--------------------------------\n\n"+"\n\n"
          // let printData=this.print.centeralign(32, "Admin App").substring(0, 32)+"\n" +this.print.centeralign(32, "NO:100, Lake View Estate,").substring(0, 32)+"\n"+this.print.centeralign(32, "Kundrathur Road,Porur,").substring(0, 32)+"\n"+this.print.centeralign(32, "Chennai, TN").substring(0, 32)+"\n"+this.print.centeralign(32, "Phone: 9876543210").substring(0, 32)+"\n"+"\n"+this.print.fillspace(16,"Invoice:" + item.name, 'backspace') + this.print.fillspace(16,"Date:"+item.order_date,'frontspace')+ "\n" + "--------------------------------\n" + this.print.fillspace(16, "Items", 'backspace') + "  Qty " + "Rate " + "Total\n"+ "--------------------------------\n" +ProductList +"--------------------------------\n" +this.print.fillspace(22, "Sub Total", 'backspace')+this.print.fillspace(10,Math.round(item.order_subtotal*100)/100 ,  'frontspace')+"\n"+this.print.fillspace(22, "GST", 'backspace')+this.print.fillspace(10,Math.round(item.total_tax_amount*100)/100,'frontspace')+"\n"+this.print.fillspace(22, "Discount", 'backspace')+this.print.fillspace(10, String(item.discount),  'frontspace') +"\n"+this.print.fillspace(22, "Delivery Charges", 'backspace')+this.print.fillspace(10, String(item.shipping_charges),  'frontspace')+"\n"+"--------------------------------\n" +this.print.fillspace(22, "Total", 'backspace')+this.print.fillspace(10,Math.round(item.total_amount*100)/100 ,  'frontspace')+"\n"+ "--------------------------------\n\n"+"\n\n"
    // let printData="admin"
    console.log(printData)
    // let printData="adjhsajkd"
    // let xyz=this.connectBT(address).subscribe(data=>{
      this.btSerial.write(printData).then(dataz=>{

        // let mno=this.alertCtrl.create({
        //   title:"P!",
        //   buttons:['Dismiss']
        // });
        // mno.present();

        // xyz.unsubscribe();
      },errx=>{
        let mno=this.alertCtrl.create({
          title:"Error "+errx,
          buttons:['Dismiss']
        });
        mno.present();
      });
      // },err=>{
      //   let mno=this.alertCtrl.create({
      //     title:"ERROR "+err,
      //     buttons:['Dismiss']
      //   });
      //   mno.present();
      // });
  }

  accepted_order(item){

    // console.log(item)business,preparation_time_id,estimated_time,is_default
    // var orderdata = {
    //   business:localStorage.restaurant,
    //   preparation_time_id:item.name,
    //   estimated_time:item.estimated_time,
    //   is_default:item.is_default
    // }
    // this.DBservice.update_restaurant_time(orderdata)
    //   .then(data => {
    //     console.log(data);
    //     this.doRefresh()
    //     // this.delivery_slot = data.message;
        
    //   }, error => {
    //     console.log(JSON.stringify(error.json()));
    //   });

  }

  valuealert(item){
    var preparation_time;
    var check_value = 0;
    for(var i=0;i < this.delivery_slot.length;i++){
      var k=i;
      if(this.delivery_slot[k].is_default  == 1){
         preparation_time = this.delivery_slot[k].estimated_time;
         check_value =1;
      }
    }
    if(localStorage.check_default == "false"){
    let modal = this.modalCtrl.create(MarkaspaidPage,{type:'date'});
    modal.present();
    modal.onWillDismiss((value: any) => {
      if (value) {
        console.log(value)
            this.orderpicked(item,'Restaurant Accepted',value.preparation_time,'')
        }
    });
  }
  else
    this.orderpicked(item,'Restaurant Accepted',preparation_time,'')

   // var modal = this.modalCtrl.create(DeliveryTimePage,{item:item,delivery:this.delivery_slot},{
      
   //    // enterAnimation: 'modal-slide-in-bottom',
      
   //    // leaveAnimation: 'modal-slide-out-bottom',
   //    // cssClass: 'my-modal'
   //      cssClass: 'slideInCustomerModal',
   //      enterAnimation: 'modal-slide-in-right',
   //      leaveAnimation: 'modal-slide-out-right',
   //      showBackdrop: true,
   //      enableBackdropDismiss: true
   //  });
   //  modal.onDidDismiss((data: any) => {
   //    console.log(data)
   //    if(data){
   //        this.accepted_order(data)
   //    }
   //        // this.createButtons(data)
   //  });

   //  modal.present();


  //   let alert = this.alertCtrl.create({
  //   subTitle: 'Preparation Time (In Minutes)',
  //   cssClass: 'alertDanger',
  //   inputs: [
  //     {
  //       name: 'username',
  //       placeholder: 'Time',
  //       type:'number'
  //     },
  //   ],
  //   buttons: [
  //     {
  //       text: 'Cancel',
  //       role: 'cancel',
  //       handler: data => {
  //         console.log('Cancel clicked');
  //       }
  //     },
  //     {
  //       text: 'Submit',
  //       handler: data => {
  //         console.log(data)
  //         if (!data.username.isValid) {
  //             if(parseInt(data.username) <= 90 && 0 < parseInt(data.username)){

                // this.orderpicked(item,'Restaurant Accepted',preparation_time,'')
                // this.orderpicked(item,'Restaurant Accepted',data.username,'')
  //             }
  //             else{
  //               this.DBservice.alert('Preparation time must be greater than 0 and Preparation time must not exceed 90 mins');
  //               return false;
  //             }
  //         } else {
  //               return false;
  //         }
  //       }
  //     }
  //   ]
  // });
  // alert.present();
  }

}

@Pipe({
  name: 'formatTime'
})
export class FormatTimePipe implements PipeTransform {

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    console.log(minutes)
    console.log(value)
    // console.log(('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(value - minutes * 60)).slice(-2))
    // localStorage.value = 
    if(minutes == 0)
      return ('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(value - minutes * 60)).slice(-2);
    // else
      // return '00 :'+'00'
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders.ts